module.exports = __webpack_public_path__ + "img/neteller_big.36ce78f8.png";